/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/require-default-props */
import React from "react";
import styled from "styled-components";
import { Badge } from "@xfrontend/xui-react-plus";

const TAG_COLORS: Record<number, { border: string; color: string }> = {
  0: { border: "var(--x-dark-display)", color: "var(--x-cyan-light)" },
  1: { border: "var(--x-dark-display)", color: "var(--x-red-light)" },
  2: { border: "var(--x-dark-display)", color: "var(--x-purple-light)" },
  3: { border: "var(--x-dark-display)", color: "var(--x-gray-400)" },
};

type ViolationPolicyTypeTagProps = {
  index?: number;
  children?: React.ReactNode;
  className?: string;
};

const StyledTag = styled(Badge)<{ $border: string; $color: string }>`
  display: inline-block;
  border-radius: 4px;
  padding: 3px 6px;
  font-size: 14px;
  line-height: 1;
  border: 1px solid ${(props) => props.$border};
  color: ${(props) => props.$color};
  background-color: var(--x-bg-400);
`;

const ViolationPolicyTypeTag = ({
  index = 0,
  children,
  className,
}: ViolationPolicyTypeTagProps): JSX.Element => {
  const colors = TAG_COLORS[index] ?? TAG_COLORS[3];
  return (
    <StyledTag bg="" $border={colors.border} $color={colors.color} className={className}>
      {children}
    </StyledTag>
  );
};

export default ViolationPolicyTypeTag;
